// #524 item 1 — defeito: o computed `reachedRemunerationsDate` (Rule.vue) e a
// replica `reachedRemunerationsDateIgnoringStartDate` (ReportsController.js)
// tinham um `return reachedDate` DENTRO do `for` que percorre os vinculos,
// fora do `if (reachedDate) break`. Isso fazia a funcao sempre retornar ja na
// 1a iteracao do loop (com ou sem carencia fechada nela), matando a data de
// "Completou em" da carencia sempre que o cliente tinha mais de um vinculo e
// o 1o nao fechava a carencia sozinho.
//
// Fix: apagar o `return` de dentro do loop. O `if (reachedDate) break` e
// MANTIDO de proposito — e ele quem garante que a funcao pare no vinculo em
// que a carencia efetivamente fechou (e nao continue somando alem do
// necessario, nem devolva a data do ultimo vinculo iterado em vinculos
// concomitantes).
//
// Extraido como funcao pura (fora do componente Vue) porque o projeto nao
// tem harness de teste para componentes Vue — mesma solucao aprovada pelo
// arbitro no card #516 (ver benefitLogsDisplayMerge.js).

const moment = require('moment');

/**
 * Percorre os vinculos qualificantes de `rule` e devolve a data em que a
 * carencia (`rule.minRemunerations`) foi efetivamente cumprida, ou `null` se
 * a regra nao tem carencia ou a carencia nao fecha nos vinculos informados.
 *
 * @param {Object} rule - objeto da regra (mesmo shape usado por Rule.vue /
 *   ReportsController.js): `minRemunerations`, `workHistory`,
 *   `remunerationType`.
 * @param {Function} countMonthsInclusiveToLimit - mesma funcao usada pelas
 *   duas replicas (assinatura: (startDateStr, endDateStr, initial, limit) =>
 *   { months, date }). Injetada para nao duplicar essa logica aqui.
 * @returns {moment.Moment|null}
 */
function computeReachedRemunerationsDate(rule, countMonthsInclusiveToLimit) {
  const necessaryRemunerations = rule?.minRemunerations || 0;
  let reachedDate = null;

  if (necessaryRemunerations) {
    const workRecords = rule?.workHistory || [];
    let remunerations = 0;

    const filteredWorkRecords = workRecords
      .filter(workRecord => workRecord.isQualifyingPeriod)
      .filter(workRecord => rule.remunerationType ? workRecord[rule.remunerationType] : true);

    for (const workRecord of filteredWorkRecords) {
      const startDate = moment(workRecord.ingressDate);
      const endDate = moment(workRecord.egressDate);

      if (startDate.isValid() && endDate.isValid()) {
        const response = countMonthsInclusiveToLimit(
          startDate.format("DD/MM/YYYY"),
          endDate.format("DD/MM/YYYY"),
          remunerations,
          necessaryRemunerations,
        );
        remunerations += response.months;
        reachedDate = response.date;

        if (reachedDate) break;
      }
    }
  }

  return reachedDate;
}

module.exports = {
  computeReachedRemunerationsDate,
};
